import { format, isValid } from 'date-fns'
import { fr, de, enUS } from 'date-fns/locale'

// Format the date safely
export const formatDate = (
  creationDate: string | Date | undefined,
  currentLanguage: string,
) => {
  if (!creationDate) return ''

  try {
    // Handle timestamp in milliseconds (number or string)
    let dateObj

    if (typeof creationDate === 'string') {
      // If it's a timestamp in string form, convert to number first
      if (/^\d+$/.test(creationDate)) {
        dateObj = new Date(parseInt(creationDate, 10))
      } else {
        // Otherwise treat as date string
        dateObj = new Date(creationDate)
      }
    } else {
      dateObj = new Date(creationDate)
    }

    if (!isValid(dateObj)) {
      return ''
    }

    const locale = {
      fr,
      de,
      en: enUS,
    }[currentLanguage]

    return format(dateObj, 'PPp', { locale })
  } catch (error) {
    console.error('Error formatting date:', error)

    return ''
  }
}
